import { render, staticRenderFns } from "./CalculationResult.vue?vue&type=template&id=61fa71b5&lang=html&"
import script from "./CalculationResult.vue?vue&type=script&lang=js&"
export * from "./CalculationResult.vue?vue&type=script&lang=js&"
import style0 from "./CalculationResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports